<template>
  <div class="cropper-container" :class="classes">
    <Cropper
      ref="cropper"
      class="cropper"
      :src="imageUrl"
      alt="Image"
      :stencil-props="config"
      @change="changeCropper"
    >
    </Cropper>
    <div class="button-container">
      <div>
        <a
          class="secondary-btn"
          :class="{ 'primary-btn': config.aspectRatio === null }"
          @click="setRatio(null)"
        >
          {{ $t("Original") }}
        </a>
        <a
          class="secondary-btn"
          :class="{ 'primary-btn': config.aspectRatio === 1 / 1 }"
          @click="setRatio(1 / 1)"
        >
          1:1
        </a>
        <a
          class="secondary-btn"
          :class="{ 'primary-btn': config.aspectRatio === 4 / 3 }"
          @click="setRatio(4 / 3)"
        >
          4:3
        </a>
      </div>
      <a class="primary-btn save-cropper js-save-cropper" @click="saveImage">{{
        $t("Save")
      }}</a>
    </div>
  </div>
</template>
<script>
// https://www.npmjs.com/package/vue-cropperjs
import { mapGetters } from "vuex";
import { Cropper } from "vue-advanced-cropper";
import useCropper from "./useCropper";
import store from "../../../store";

export default {
  components: {
    Cropper,
  },
  props: {
    imageUrl: {
      type: String,
    },
    classes: {
      type: String,
      default: () => "",
    },
    storeNamespace: {
      type: String,
      default: () => "cropper/",
    },
  },
  computed: {
    ...mapGetters({
      product: "product/getProduct",
    }),
  },
  data() {
    return {
      config: {},
    };
  },
  methods: {
    saveImage() {
      this.$emit("save-modified");
    },
    changeCropper({ canvas }) {
      const image = this.compressImage(canvas);

      store.commit(`${this.storeNamespace}SET_FILE`, image);
    },
    setRatio(value) {
      this.config.aspectRatio = value;

      if (value === null) {
        this.updateCropperSize();
      }

      this.$refs.cropper.refresh(); // update by ratio
    },
    updateCropperSize() {
      const cropper = this.$refs.cropper;

      cropper.setCoordinates([
        ({ imageSize, visibleArea }) => ({
          width: (visibleArea || imageSize).width,
          height: (visibleArea || imageSize).height,
        }),
      ]);
    },
  },
  mounted() {
    this.config.aspectRatio = 1 / 1;
  },
  setup() {
    const { compressImage } = useCropper();

    return {
      compressImage,
    };
  },
};
</script>
